import { FormikContextType } from 'formik';
import { useCallback, useState } from 'react';

import { FormFieldType } from '../form/keys';

interface UseConfirmationModalProps {
  form: FormikContextType<Record<FormFieldType, any>>;
}

export const useConfirmationModal = ({ form }: UseConfirmationModalProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = useCallback(async () => {
    const errors = await form.validateForm();
    if (Object.keys(errors).length === 0) {
      setIsOpen(true);
    } else {
      form.setTouched(Object.keys(errors).reduce((acc, key) => ({ ...acc, [key]: true }), {}));
    }
  }, [form]);

  const confirm = useCallback(() => {
    setIsOpen(false);
    form.submitForm();
  }, [form]);

  const cancel = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    isOpen,
    openModal,
    confirm,
    cancel,
  };
};
